module.exports = __webpack_public_path__ + "static/img/check2.7f0ac2c0.png";